import { render, staticRenderFns } from "./frontDropDown.vue?vue&type=template&id=5b3934f6&"
import script from "./frontDropDown.vue?vue&type=script&lang=js&"
export * from "./frontDropDown.vue?vue&type=script&lang=js&"
import style0 from "./frontDropDown.vue?vue&type=style&index=0&id=5b3934f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports